// Авто-мут оркестратора на время записи голосового (lib/micBusy).
//
// Чистая логика без звука и сокета — чтобы её можно было проверить отдельно.
// muted — микрофон оркестратора выключен (как бы ни выключили);
// autoMuted — выключили МЫ из-за записи: только такой мут снимаем сами.

export interface MuteState {
  muted: boolean
  autoMuted: boolean
}

export interface RecordingStep extends MuteState {
  /** заглушить звучащий ответ (как при перебивании) */
  silence: boolean
}

/** Запись голосового началась (recording) или все записи кончились.
 *  live — разговор поднят. */
export function recordingStep(s: MuteState, recording: boolean, live: boolean): RecordingStep {
  if (recording) {
    if (!live) return { ...s, silence: false }
    // выключенный руками микрофон не трогаем и своим не считаем
    if (s.muted) return { ...s, silence: true }
    return { muted: true, autoMuted: true, silence: true }
  }
  if (s.autoMuted) return { muted: false, autoMuted: false, silence: false }
  return { ...s, silence: false }
}

/** Кнопка микрофона: ручное решение сильнее автоматического. */
export function manualToggle(s: MuteState): MuteState {
  return { muted: !s.muted, autoMuted: false }
}

/** Глушить ли входящий звук ответа: пока идёт запись при выключенном микрофоне
 *  и до конца ответа, прерванного записью (tail). */
export function dropsAudio(recording: boolean, muted: boolean, tail: boolean): boolean {
  return (recording && muted) || tail
}
